export class UserPass {
  constructor(
    public id: number,
    public username: string,
    public password: string,
    public confirmation: string
  ) {}

  passwordsMatch(): boolean {
    return this.password === this.confirmation;
  }
}
